import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { authService } from '../../../services/auth';
import Constants from '../../../app.constants';

import LoginNav from './new-login-nav';
import Maintenance from './maintenance';

import './new-login.scss';

class NewLogin extends Component {
  constructor(props) {
    super(props);

    this.Constants = Constants;
    this.AuthService = authService;
    this.showMaintenance = false;

    this.state = {
      credentials: {
        username: '',
        password: '',
      },
      usernameValidation: '',
      passwordValidation: '',
    };
  }

  handleFormChange(field) {
    return event => {
      this.setState({
        ...this.state,
        credentials: {
          ...this.state.credentials,
          [field]: event.target.value,
        },
      });
    };
  }

  validateCredentials() {
    this.setState({ usernameValidation: '', passwordValidation: '' });
    let usernameValidation;
    let passwordValidation;

    if (!this.state.credentials.username) {
      usernameValidation = 'Please enter a valid email address.';
    }

    if (!this.state.credentials.password) {
      passwordValidation = 'Please enter a password to sign in.';
    }

    if (usernameValidation || passwordValidation) {
      this.setState({ usernameValidation, passwordValidation });
      return false;
    }

    return true;
  }

  redirectAfterLogin() {
    /*
     * Redirect user back to the page they were on previously
     * if their token expired while still in the app
     */
    try {
      const params = new URLSearchParams(this.props.location.search);
      const redirect = params.get('redirect') || '/v2';
      this.props.history.push(redirect);
    } catch (e) {
      console.error(e);
    }
  }

  redirectToChangePassword(statusCode) {
    this.props.history.push({
      pathname: '/v2/reset-password-completion',
      search: `?code=${statusCode}`,
      state: {
        newUser: true,
        credentials: {
          username: this.state.credentials.username,
          old_password: this.state.credentials.password,
        },
      },
    });
  }

  handleError(error) {
    if (!error) return;

    if (error.code === 4305) {
      this.setState({ usernameValidation: '', passwordValidation: '' });
      this.redirectToChangePassword(error.code);
    } else if (error.code === 7000) {
      const downtimeMsg =
        'The Narrativ platform is down for maintenance. ' + 'Please try again in a few minutes.';
      this.setState({ passwordValidation: error.message || downtimeMsg });
    } else if ([4001, 4002, 4301].includes(error.code)) {
      this.setState({ passwordValidation: 'Your email or password is incorrect.' });
    }
  }

  login(event) {
    event.preventDefault();

    if (!this.validateCredentials()) return;

    const loginData = {
      ...this.state.credentials,
      client_id: this.Constants.CLIENT_ID,
      client_secret: this.Constants.CLIENT_SECRET,
    };
    return this.AuthService.login(loginData).then(
      () => this.redirectAfterLogin(),
      error => this.handleError(error),
    );
  }

  render() {
    const { isMobile } = this.props;
    const { newUser } = this.props;
    const contentHeaderText = newUser ? 'New account' : 'Sign in';
    const mainContentText = newUser
      ? `WELCOME. LET'S GET YOU SET UP.`
      : `WELCOME. LET'S GET YOU SIGNED IN.`;

    const maintenanceMessage = this.showMaintenance ? (
      <Maintenance dateString="Friday Jan. 17, 10AM - 12PM EST" isMobile={isMobile} />
    ) : null;

    const headerLine = !this.showMaintenance ? <span className="line"></span> : null;

    const contentHeader = !(this.showMaintenance && isMobile) ? (
      <div className="content-header">
        <span className="text">{contentHeaderText}</span>
        {headerLine}
      </div>
    ) : null;

    const buttonSubmit = (
      <button className="submit-btn">{newUser ? 'NEXT STEP' : 'SIGN IN'}</button>
    );

    const buttons = newUser ? (
      buttonSubmit
    ) : (
      <>
        {buttonSubmit}
        <a className="forgot-password-btn" href="/v2/reset-password-request">
          FORGOT PASSWORD?
        </a>
      </>
    );

    return (
      <div className={`new-login${isMobile ? ' mobile' : ''}`}>
        <LoginNav isMobile={isMobile} />
        <div className="content">
          {maintenanceMessage}
          {contentHeader}
          <div className="main-content">
            <h1 className="text">{mainContentText}</h1>
            <form className="login-form" onSubmit={this.login.bind(this)}>
              <div className="input-label">Email address</div>
              <input
                type="text"
                value={this.state.credentials.username}
                onChange={this.handleFormChange('username')}
                className="username"
              />
              <p className="warning">{this.state.usernameValidation}</p>
              <div className="input-label">{newUser ? 'Temporary password' : 'Password'}</div>
              <input
                type="password"
                value={this.state.credentials.password}
                onChange={this.handleFormChange('password')}
                className="password"
              />
              <p className="warning">{this.state.passwordValidation}</p>
              <div className="buttons">{buttons}</div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(NewLogin);
